// Used on the Resource page to create links and descriptions to other websites or documents
function ResourceButton({ title, description, url }) {
    return (
        <a
            href={url}
            class='resource-button'
            target='_blank'
            rel='noopener noreferrer'
        >
            <div>{title}</div>
            <p>{description}</p>
        </a>
    );
}

export default ResourceButton